import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Message } from "@qgiv/core-react";
import ConnectedErrorRedirect from "./ConnectedErrorRedirect";

const ErrorDisplay = ({
    errors = [],
    setErrors = () => {},
    erroredEntities = [],
}) => {
    // erroredEntities gets reset to empty array almost immediately
    // this state tracks when they are first entered into state
    const [localErroredEntities, setLocalErroredEntities] = useState([]);
    useEffect(() => {
        if (localErroredEntities.length === 0 && erroredEntities.length > 0) {
            setLocalErroredEntities(erroredEntities);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [erroredEntities]);

    return errors.length > 0 && Array.isArray(errors) ? (
        <div className="grid">
            <div className="col col--12">
                <Message
                    closeButton
                    onClose={() => {
                        setErrors([]);
                    }}
                    scrollToMessage
                >
                    <p>
                        {errors.map((error, i) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <span key={i}>
                                {`${error} `}
                                {localErroredEntities.length === 0 && <br />}
                            </span>
                        ))}
                        {localErroredEntities.length > 0 && (
                            <ConnectedErrorRedirect
                                localErroredEntities={localErroredEntities}
                            />
                        )}
                    </p>
                </Message>
            </div>
        </div>
    ) : null;
};

ErrorDisplay.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.string),
    setErrors: PropTypes.func.isRequired,
    erroredEntities: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ErrorDisplay;
